/**
 * Lightweight event bus for notifying UserDataSyncContext
 * when favorites or builds change in localStorage.
 *
 * Using a custom DOM event avoids prop-drilling and keeps
 * useFavoritesV2 / PCBuildManager changes minimal.
 */

const EVENT_NAME = 'pcb:data-changed'

/** Dispatch from any hook or component when local data changes */
export function emitDataChanged(): void {
  window.dispatchEvent(new CustomEvent(EVENT_NAME))
}

/** Subscribe in UserDataSyncContext */
export function onDataChanged(handler: () => void): () => void {
  window.addEventListener(EVENT_NAME, handler)
  return () => window.removeEventListener(EVENT_NAME, handler)
}
